<template>
  <div>
  </div>
</template>

<script>

export default {
  name: 'AppMain',
  components: {
    
  },
  methods : {

  },

  created() {
  }

}
</script>

<style>
body {
  margin:0px;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin:0px;
  padding:0px;
  /* margin-top: 60px; */
}
</style>
